import { TOKEN_URL } from '@/api/auth';
import { useAuthStore } from '@/stores/auth';
import router from '@/router';
import { showErrorToUser } from '@/utils/request/showErrorToUser';

export const onResponseRejected = async (error: any) => {
  const statusCode = error.response?.status;
  const authStore = useAuthStore();

  if (statusCode === 401 && error.config.url !== TOKEN_URL) {
    authStore.setIsAuthorized(false);
    return router.push({ name: 'login' });
  }

  // If user tries to login with existing account that has no organization (django admin account for example)
  if (
    statusCode === 403 &&
    !error.config.url.includes('totp') &&
    !(
      error.config.url.includes('api/v1/controllers/') &&
      error.config.method === 'delete'
    )
  ) {
    router.push({ name: 'security' });
  }

  // Pass 4XX errors to toast
  if (
    `${error.response?.status}`[0] === '4' &&
    !error.config.url.includes('totp') &&
    !error.config.url.includes('change') &&
    !['totp_expired', 'totp_required'].includes(error.response.data.code)
  ) {
    showErrorToUser(error);
  }

  return Promise.reject(error);
};
